  import PropTypes from 'prop-types';
import { useState } from 'react';
import BookingPagination from '../Bookings/BookingPagination';
import AllBookingsViewer from '../Bookings/AllBookings';
import './bookingactions.css';

const BookingActions = ({ operators, operatorId, enablePaginated, enableLoadAll }) => {
  const [viewMode, setViewMode] = useState(null); // 'new', 'updated', 'cancelled', 'allNew', 'allUpdated', 'allCancelled'
  
  // Convert operatorId to number for consistent typing
  const operatorIdAsNumber = operatorId ? parseInt(operatorId, 10) : null;

  const renderComponent = () => {
    switch (viewMode) {
      case 'new':
        return <BookingPagination operators={operators} operatorId={operatorIdAsNumber} bookingType="new"  />;
      case 'updated':
        return <BookingPagination operators={operators} operatorId={operatorIdAsNumber} bookingType="updated"   />;
      case 'cancelled':
        return <BookingPagination operators={operators} operatorId={operatorIdAsNumber} bookingType="cancelled"   />;
      case 'allNew':
        return <AllBookingsViewer operators={operators} bookingType="new"  />;
      case 'allUpdated':
        return <AllBookingsViewer operators={operators} bookingType="updated"  />;
      case 'allCancelled':
        return <AllBookingsViewer operators={operators} bookingType="cancelled"  />;
      default:
        return null;
    }
  };

  return (
    <div>
      <button className="themed-button" disabled={!enableLoadAll} onClick={() => { setViewMode('allNew');  }}>
        Load All New Bookings
      </button>
      <button className="themed-button" disabled={!enableLoadAll} onClick={() => { setViewMode('allUpdated');  }}>
        Load All Updated Bookings
      </button>
      <button className="themed-button" disabled={!enableLoadAll} onClick={() => { setViewMode('allCancelled');  }}>
        Load All Cancelled Bookings
      </button>
      <br />
      <button className="themed-button" disabled={!enablePaginated} onClick={() => { setViewMode('new'); }}>
        Load New Bookings (Paginated)
      </button>
      <button className="themed-button" disabled={!enablePaginated} onClick={() => { setViewMode('updated');  }}>
        Load Updated Bookings (Paginated)
      </button>
      <button className="themed-button" disabled={!enablePaginated} onClick={() => { setViewMode('cancelled');  }}>
        Load Cancelled Bookings (Paginated)
      </button>
      <div style={{ marginTop: '2rem' }}>
        {renderComponent()}
      </div>
    </div>
  );
};

BookingActions.propTypes = {
  operators: PropTypes.array.isRequired,
  operatorId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  enablePaginated: PropTypes.bool,
  enableLoadAll: PropTypes.bool,
};


export default BookingActions;